import * as React from 'react';

import { useModalContext } from 'common/contexts';
import ConfEnableDisablePacks from 'illuminate/components/content-hub/modals/ConfActionOnPacks';
import useSelectedEntities from 'components/common/EntityDataTable/hooks/useSelectedEntities';

export type TCWPacksModalTypes =
  | 'CONFIRM_ENABLE_PACKS'
  | 'CONFIRM_DISABLE_PACKS'
  | 'CONFIRM_ENABLE_SINGLE_PACK'
  | 'CONFIRM_DISABLE_SINGLE_PACK';

function PacksModals() {
  const { modal, setModal, setEntity } = useModalContext();
  const { setSelectedEntities: setBulkSelectedEntities } = useSelectedEntities();

  const onClose = () => {
    setEntity(null);
    setModal(null);
    setBulkSelectedEntities([]);
  };

  switch (modal) {
    case 'CONFIRM_ENABLE_PACKS':
    case 'CONFIRM_DISABLE_PACKS':
    case 'CONFIRM_ENABLE_SINGLE_PACK':
    case 'CONFIRM_DISABLE_SINGLE_PACK':
      return <ConfEnableDisablePacks onCancel={onClose} />;
    default:
      return null;
  }
}

export default PacksModals;
